import mapActions from './mapActions';

export default mapActions('work_performance', {
    fetchAll_url: data => `/api/building_entities/${data.id}/work_history`
});
